import tippy, { type Instance as TippyInstance } from "tippy.js";

export const COLLABORATE_SUGGESTION_TIPPY_THEME = "collaborate-suggestion";

type SuggestionTippyOptions = {
  getReferenceClientRect: () => DOMRect;
  content: Element;
};

/** Tippy instance for slash / mention suggestion menus (chrome-free; content owns the surface). */
export function createCollaborateSuggestionTippy(
  options: SuggestionTippyOptions
): TippyInstance[] {
  return tippy("body", {
    getReferenceClientRect: options.getReferenceClientRect,
    appendTo: () => document.body,
    content: options.content,
    showOnCreate: true,
    interactive: true,
    trigger: "manual",
    placement: "bottom-start",
    maxWidth: 320,
    offset: [0, 6],
    theme: COLLABORATE_SUGGESTION_TIPPY_THEME,
    arrow: false,
  });
}
